import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import Lodinging from "../components_root/loading.jsx";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './products-list.css';
import { Toast } from '../components_root/ToastContext';
import { VscDashboard } from "react-icons/vsc";
import { IoIosGitCompare } from "react-icons/io";
import { MdAdd, MdAnalytics, MdDashboard, MdHome, MdClose, MdLocationCity, MdMenu, MdMonitor, MdOutlineAnalytics, MdSettings, MdSettingsAccessibility, MdTraffic, MdShoppingCart, MdVisibility, MdOutlineShoppingCartCheckout, MdEdit } from "react-icons/md";
import { Save_products } from "./save_products";
import { reload } from "firebase/auth";
import { Randomcode } from "../components_root/rendom_code.js";
import CopyUID from "../components_root/copyuid.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};


export default function Products_list() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [activeTab, setActiveTab] = useState("home");
    const [categoryData, setCategoryData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [modelname, setModelname] = useState("");
    const [productsdata, setProductsdata] = useState("");
    const [itemname, setitemname] = useState("");
    const [usecase, setUsecase] = useState("");
    const [titlename, setTitlename] = useState("");
    const [brandname, setBrandname] = useState("");
    const [itemcode, setItemcode] = useState(Randomcode(10));
 

    const saveproducts = async () => {
    if (!brandname) return Toastshow("Please enter brand name");
        if (!selectedCategory) return Toastshow("Please select a category");
        if (!selectedSubcategory.trim()) return Toastshow("Please enter a subcategory");
        if (!itemname.trim()) return Toastshow("Please enter a item name");
        if (!usecase.trim()) return Toastshow("Please enter a use case");
        if (!modelname) return Toastshow("Please enter modelname");
        if (!titlename.trim()) return Toastshow("Please enter title ");
        if (!itemcode.trim()) return Toastshow("Please enter itemcode");
        try {
            const slug = titlename
                .toLowerCase()
                .replace(/[^a-z0-9\s]/g, "")
                .trim()
                .replace(/\s+/g, "-")
                .substring(0, 50) + "-" + Randomcode(2);
            const result = await Save_products({
                slug,
                itemcode,
                brandname:brandname.trim().toLocaleLowerCase(),
                modelname: modelname.trim().toLocaleLowerCase(),
                category: selectedCategory.trim().toLocaleLowerCase(),
                subcategory: selectedSubcategory.trim().toLocaleLowerCase(),
                item: itemname.trim().toLocaleLowerCase(),
                usecase: usecase.trim().toLocaleLowerCase(),
                title: titlename.trim().toLocaleLowerCase(),
            });

            if (result.success) {
                get_products();
                Toastshow("Saved successfully!");
                fetchCategory();
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };

    const fetchCategory = async () => {
        setIsLoading2(true);
        try {
            const categoryQuery = query(
                collection(db, "category"),
            );

            const snapshot = await getDocs(categoryQuery);
            const docs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    const subcategories = [];
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        if (fieldName === "subcategory" && fieldValue) {
                            subcategories.push(fieldValue);
                        }
                    });
                    return { uid: docSnap.id, category: docData.category, subcategories };
                })
            );

            setCategoryData(docs);
        } catch (err) {
            console.error("Error fetching categories:", err);
        }
        setIsLoading2(false);
    };

    useEffect(() => {
        fetchCategory();
    }, []);
    //setProductsdata
    const fetchproducts = async () => {
        setIsLoading(true);
        try {
            const companyuid = Cookies.get("select_company_uid");
            if (!companyuid) {
                console.error("Missing company UID or GUID");
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            const Query = query(
                collection(db, "products"),
                where("category", "==", selectedCategory.trim().toLocaleLowerCase()),
                where("subcategory", "==", selectedSubcategory.trim().toLocaleLowerCase()),
                where("companyuid", "==", companyuid)
            );

            const snapshot = await getDocs(Query);
            const products = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    let child = {};
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        child[fieldName] = fieldValue;
                    });
                    return { uid: docSnap.id, ...docData, child };
                })
            );


            setProductsdata(products);
            setIsLoading(false);
        } catch (err) {
            console.error("Error fetching products:", err);
        }
        setIsLoading(false);
    };
    useEffect(() => {
        // Fetch products whenever selectedCategory or selectedSubcategory changes
        fetchproducts();
    }, [selectedCategory, selectedSubcategory]);

    //
    //setProductsdata

    const get_products = async () => {
        setIsLoading(true);
        try {
            const companyuid = Cookies.get("select_company_uid");
            if (!companyuid) {
                console.error("Missing company UID or GUID");
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            const Query = query(
                collection(db, "products"),
                where("companyuid", "==", companyuid)
            );

            const snapshot = await getDocs(Query);
            const products = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    let child = {};
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        child[fieldName] = fieldValue;
                    });
                    return { uid: docSnap.id, ...docData, child };
                })
            );

            setProductsdata(products);
            setIsLoading(false);
        } catch (err) {
            console.error("Error fetching products:", err);
        }
        setIsLoading(false);
    };
    useEffect(() => {
        get_products();
    }, []);
    return (
        <div>
            <div className="post-container">
                <div className="post_div">
                    <table >
                        <tr>

                            <td className="text-h2 bold">Product  Category byes</td>
                        </tr>
                    </table>

                    <div className="products_list_container" >
                        {isLoading2 ? (
                            <Lodinging />
                        ) : categoryData.length === 0 ? (
                            <div>No categories found</div>
                        ) : (
                            <div>
                                <table>
                                    <tr>
                                        <td>

                                            <select
                                                value={selectedCategory}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    setSelectedCategory(val);
                                                    setSelectedSubcategory("");
                                                    if (val === "All") {
                                                        // fetchPhonebook(); // implement this if needed
                                                    } else {
                                                        // fetch_by_CategoryData(val); // implement this if needed
                                                    }
                                                }}
                                                className="button-ui2 rounded fcap p-2 bold fill"
                                            >
                                                <option value="All">All</option>
                                                {categoryData.map((c) => (
                                                    <option key={c.uid} value={c.category}>
                                                        {c.category}
                                                    </option>
                                                ))}
                                            </select>

                                        </td>

                                        <td>
                                            <select
                                                value={selectedSubcategory}
                                                onChange={(e) => {
                                                    const sub = e.target.value;
                                                    setSelectedSubcategory(sub);
                                                    // fetch_by_subcategory(sub); // implement this if needed
                                                }}
                                                className="button-ui2 rounded fcap p-2 bold fill"
                                                disabled={selectedCategory === "All"}
                                            >
                                                <option value="">Subcategory</option>
                                                {categoryData
                                                    .filter((c) => c.category === selectedCategory)
                                                    .flatMap((c) => c.subcategories)
                                                    .map((s, i) => (
                                                        <option key={i} value={s}>
                                                            {s}
                                                        </option>
                                                    ))}
                                            </select>

                                        </td>
                                    </tr>
                                </table>
                            </div>
                        )}
                    </div>
                    <div className="ui-grid">
                        <div className="ui-items">
                            <table>
                                <tr>
                                    <td>
                                        <table >
                                            <tr>
                                                <td>
                                                    <div className="text-h3 m-1">Item Code used as Variation: Color / Size</div>
                                                </td>
                                                <td width={25}>
                                                    <div onClick={() => setItemcode(Randomcode(10))} ><MdAdd className="icon cursor b-1 " /></div>
                                                </td>
                                            </tr>

                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-h2 bold"><input value={itemcode} maxLength={30} onChange={(e) => setItemcode(e.target.value)} className="bold" type="text" placeholder="Product Item name" /></td>
                                </tr>
                                   <tr>
                                           <td width={80} className="bold text-h3">Brand name</td>
                                </tr>
                                        <tr>
                                     
                                            <td className="text-h2 bold"><input value={brandname} maxLength={50} onChange={(e) => setBrandname(e.target.value)} type="text" placeholder="Brand name" /></td>
                                        </tr>
                                <tr>
                                    <td className="bold text-h3">Item name</td>
                                </tr>
                                <tr>
                                    <td className="text-h2 bold"><input value={itemname} maxLength={30} onChange={(e) => setitemname(e.target.value)} className="bold" type="text" placeholder="Product Item name" /></td>
                                </tr>
                                <tr>
                                    <td className="bold text-h3">Usecase name</td>
                                </tr>
                                <tr>
                                    <td className="text-h2 bold"><input value={usecase} maxLength={50} onChange={(e) => setUsecase(e.target.value)} type="text" placeholder="Usecase name" /></td>
                                </tr>
                             
                                <tr>
                                    <td className="bold text-h3">Model name</td>
                                </tr>
                                <tr>
                                    <td className="text-h2 bold"><input value={modelname} maxLength={50} onChange={(e) => setModelname(e.target.value)} type="text" placeholder="Model name" /></td>
                                </tr>
                                <tr>
                                    <td className="bold text-h3">Title name</td>
                                </tr>
                                <tr>
                                    <td className="text-h2 bold"><textarea value={titlename} maxLength={200} onChange={(e) => setTitlename(e.target.value)} type="text" placeholder="Title name" /></td>
                                </tr>
                                <tr>
                                    <td><div onClick={saveproducts} className="button-ui fill p-2 text-h2 cursor"><MdAdd className="icon" />Continue</div></td>
                                </tr>
                            </table>
                        </div>

                        {isLoading ? (
                            <Lodinging />
                        ) : productsdata.length === 0 ? (
                            <div>No categories found</div>
                        ) : (
                            productsdata.map((row, index) => (
                                <div className="ui-items items-back border rounded" key={index}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <img src={row.thumbnail} onClick={() => {
                                                    setActiveTab("productsedit");
                                                    navigate("?menu=productsedit&uid=" + row.uid);
                                                    window.location.reload();
                                                }} className="ads-items-default" />
                                            </tr>
                                            <tr>
                                                <td ><div className="text-h2 fcap bold">{row.item}/ {row.usecase}</div></td>
                                            </tr>
                                            <tr>
                                                <td ><div className="text-h3 fcap">{row.category}/ {row.subcategory}</div></td>
                                            </tr>

                                            <tr>
                                                <td><div className="text-h3 text-off">{row.title}</div></td>
                                            </tr>


                                        </tbody>
                                    </table>
                                    <table className="b-top m-bottom">
                                        <tr>
                                            <td className="text-h3 text-off">Update:</td>
                                            <td className="text-h3 bold">{" "}
                                                {row.update_date_time?.toDate ? (
                                                    (() => {
                                                        const dateObj = row.update_date_time.toDate();
                                                        return `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
                                                    })()
                                                ) : (
                                                    "No data"
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3 text-off">Create:</td>
                                            <td className="text-h3 text-off">{" "}
                                                {row.date_time?.toDate ? (
                                                    (() => {
                                                        const dateObj = row.date_time.toDate();
                                                        return `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
                                                    })()
                                                ) : (
                                                    "No data"
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3 text-off">Colour:</td>
                                            <td>
                                                <div className="center text-h2  sline">

                                                    {row.child?.colorname || "Color Name"} </div>
                                            </td>
                                            <td className="rounded"
                                                width={25}
                                                style={{ backgroundColor: row.child?.color || "#000" }}
                                            ></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3 text-off">Item Code</td>
                                            <td className="text-h2 bold">{row.itemcode}</td>
                                            <td width={25}>{<CopyUID id={row.itemcode} />}</td>
                                        </tr>
                                    </table>
                                    <table>
                                        <tr>
                                            <td className="text-h3 text-off">ID</td>
                                            <td className="text-h3 ">{row.uid}</td>
                                            <td width={25}> </td>
                                        </tr>
                                    </table>
                                    <div>
                                        <table>
                                            <tr>
                                                <td>
                                                    <div title="Views" className="button-ui2 cursor"><MdVisibility className="icon" /> {row.views || "0"} Views</div>   </td>
                                                <td>
                                                    <div title="Orders" className="button-ui2 cursor"><MdOutlineShoppingCartCheckout className="icon" /> {row.orders || "0"}</div>
                                                </td>
                                                {/* <td>
                                                    <div className="button-ui2 cursor" onClick={() => {
                                                        setActiveTab("productsedit");
                                                        navigate("?menu=productsedit&uid=" + row.uid);
                                                        window.location.reload();
                                                    }}><MdEdit className="icon" />Edit</div>
                                                </td> */}
                                                <td>
                                                    <div title="Compare" className="button-ui2 cursor"><IoIosGitCompare className="icon" /> {row.compare || "0"}</div>   </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
